<template>
    <div class="ReMarketingHistory p-4 mb-5" v-if="this.ApiData.length > 0">
		<div class="d-flex justify-content-between">
			<!--h4 class="mr-2">История подачи в рекламу</h4-->
			<!-- <el-tooltip content="Обновить историю" placement="top"><button type="button" class="btn my-0 btn-icon btn-fab btn-primary btn-simple" @click="getApiData()"><i class="d-inline-block tim-icons icon-refresh-02"></i></button>
			</el-tooltip> -->
		</div>
		<el-table ref="multipleTable" :data="ApiData" style="width: 100%">	
			
			<el-table-column
			label="Пакет"
			min-width="150"
			prop="name">
			</el-table-column>

			<el-table-column 
				min-width="400"
				label="Площадки"
				property="sites">
				<template v-slot="scope">
					<!-- <ul class="service-list ">
						<li v-for="item in JSON.parse(scope.row.sites)" class="">
							<div class="service-table-col px-4">
								<span>{{item.site}}, {{ item.term }}</span>
							</div>
						</li>
					</ul> --> <!-- это была красивая и правильная версия, пока заказчики всё не испортили -->
					<div :class="[(getSites(scope.row.sites).length>1) ? 'expand-hidden' : 'expand-visible']" :id="scope.$index">
						<ul class="row service-list " >
							<li v-for="(item,index) in getSites(scope.row.sites)" class="col-xl-6 col-lg-12" :key="index">
								<div class="service-table-col px-4">
									<span>{{item.site}}, {{ item.term }}</span>
								</div>
							</li>
						</ul>
					</div>
					<div class="openbtn-container position-btn" >
						<button class="expandBtn" @click="toggleBtn(scope.$index)"> <span :id="'text_'+scope.$index"  v-if="getSites(scope.row.sites).length>6">Показать всё</span>
							<!--span v-if="getSites(scope.row.sites).length!=1 && JSON.parse(scope.row.sites).length<2">Скрыть</!--span--></button>
					</div>
					
				</template>
			</el-table-column>

			<el-table-column
			label="Старт"
			min-width="120"
			prop="dfrom">
				<template v-slot="scope">
					{{ $GVO.convertDateFromMysql(scope.row.dfrom) }}
				</template>
			</el-table-column>

			<el-table-column
			label="Снятие (в 00:01)"
			min-width="120"
			prop="dto">
				<template v-slot="scope">
					{{ $GVO.convertDateFromMysql(scope.row.dto) }}
				</template>
			</el-table-column>

		</el-table>
		
    </div>
</template>
<script>

import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
// import { BaseRadio } from 'src/components/index';
// import Pagination from 'src/our_components/RePagination';

export default {
	name: 'ReMarketingHistory',
	components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
    // Pagination,
    // BaseRadio,
},
	data() {
		return {
			// let result_id = typeof this.$route.params.plan_id=='undefined'?null:this.$route.params.plan_id;
			ApiData: [],
			objGetParams:{},
			masObjects_total: 0,
			bShowFilter: false,
			objChosenTP:{},
			itogBet: 0,
		};
	},
	props: {
		// objData: Object,
		objId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: [String, Number],
			default: '',
		},
	},
	methods: {
		getApiData(){
			this.$GVO.ApiCall('marketing_plan.GET_object_marketing',{
				flt:{
					'object_id':this.objId,
					'older':1,
				}
			})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
						// this.$refs.multipleTable.doLayout();


					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},

		pClick(e){
			this.objGetParams['p'] = parseInt(e);
		},
		toggleBtn(data) {
			let element = document.getElementById(`${data}`);
			let btn = document.getElementById(`text_${data}`);
			// btn.innerText = 'Скрыть';
			// console.log(btn.innerText );
			if(element.classList.contains('expand-hidden')){
				btn.innerText = 'Скрыть';
				element.classList.remove('expand-hidden');
				element.classList.add('expand-visible');
			} else if (element.classList.contains('expand-visible')){
				btn.innerText = 'Показать всё';
				element.classList.remove('expand-visible');
				element.classList.add('expand-hidden');
			}
		},
		getSites(sites){
			let result = [];
			try{
				result = JSON.parse(sites)
			}catch(e){

			}
			return result;
		}

	},		
	mounted(){
		this.getApiData();
	}
};
</script>
<style scoped>

.ReMarketingHistory {border: 1px solid #01b0e0; padding: 20px 5px 0px 15px; border-radius: 6px;}
.expandBtn {
	background-color: transparent;
	border: none;
	outline: none;
	color: #9e77f3;
	
}
.expandBtn:hover {
	color: #01b0e0;
}
.expand-hidden {
	/* max-height: 26rem; */
	max-height: 110px;
	overflow: hidden;
	padding-bottom: 30px;
}
.expand-visible {
	height: auto;
}
.white-content .card:not(.card-white) .position-btn{
		background-color: #fff;
	}
.position-btn {
	position: absolute;
	bottom: 5px;
	z-index: 2;
	background-color: #27293d;
	width: 100%;
	padding-top: 3px;
}
.position-btn-shadow { box-shadow: 0px 3px 15px 0px rgba(123, 123, 123, 0.7) !important;}

</style>
